// extracted by mini-css-extract-plugin
module.exports = {"flight":"flight-1gcv-","flight_open":"flight_open-1oiFm","flight__content":"flight__content-QZRZc","fareGroups":"fareGroups-3qv_j"};